export const brandColorsLegacy = {
  black: '#000',
  white: '#fff',
  transparent: 'rgba(0, 0, 0, 0)',
  transparentWhite: 'rgba(255, 255, 255, 0)',
  defaultPurple: '#800080',
  lightPurple: '#925EB1',
  greenlight: '#00A579',
  pavement: '#212529',
  concrete: '#444f56',
  shoulder: '#f1f3f5',
  centerline: '#ffc72c',
  pine: '#14845f',
  pineDark: '#004632',
  pineLight: '#b4ecdc',
  steelDark: '#868e96',
  steelLight: '#ced4da',
  activeBlue: '#2298fe',
  error: '#bd1a1d',
  errorLight: '#fce8e8',
  info: '#005cb2',
  infoLight: '#eef7ff',
  infoDark: '#003b72',
  infoMedium: '#cfe8ff',
  warning: '#d76106',
  warningLight: '#fff5de',
}
